import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { MercadoFilter } from '../filter';
import { mercadoAtivo, mercadoInativo, MercadoSituacaoFilterPipe } from '../situacao';
import { MercadoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-mercado-multiselect',
    templateUrl: './mercado-multiselect.component.html',
    styleUrls: ['./mercado-multiselect.component.less']
})
export class MercadoMultiselectComponent implements OnInit {
    /** Mercados selecionados */
    @Input() idsMercados: number[];
    /** Ao alterar a seleção dos mercados */
    @Output() idsMercadosChange = new EventEmitter<number[]>();

    /** Se deve exibir os mercados ativos */
    @Input() ativos = true;
    /** Se deve exibir os mercados inativos */
    @Input() inativos = true;
    /** Se deve exibir a opção de selecionar a opção de mercado nulo ou seja, para filtrar registros que não possuem o mercado */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o mercado nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção do mercado nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Mercado';
    @Input() checked = 'Mercado';
    @Input() checkedPlural = 'Mercados';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum mercado encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private mercadoSituacaoFilterPipe: MercadoSituacaoFilterPipe,
                private mercadoCrudHttpService: MercadoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-mercado ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Obtem as situações dos mercados conforme as opções desejadas */
    private getSituacoes(): number[] {
        const situacoes: number[] = [];
        // Ativos
        if (this.ativos) {
            situacoes.push(mercadoAtivo.id);
        }
        // Inativos
        if (this.inativos) {
            situacoes.push(mercadoInativo.id);
        }

        return situacoes;
    }

    /** Cria os mercados para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new MercadoFilter();
        filter.situacoes = this.getSituacoes();
        this.mercadoCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Opção de selecionar a opção de mercado nulo
                    if (this.showNullOption) {
                        selects.push({
                            id: 0,
                            name: 'NÃO INFORMADO'
                        });
                    }

                    // Ativos
                    if (this.ativos) {
                        selects.push({
                            id: -1,
                            name: 'ATIVOS',
                            isLabel: true
                        });

                        this.mercadoSituacaoFilterPipe.transform(entities, mercadoAtivo.id)?.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                    }

                    // Inativos
                    if (this.inativos) {
                        selects.push({
                            id: -2,
                            name: 'INATIVOS',
                            isLabel: true
                        });

                        this.mercadoSituacaoFilterPipe.transform(entities, mercadoInativo.id)?.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                    }

                    this.options = selects;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os mercados', error);
                }
            );
    }

    /** Ao alterar a seleção da opção do mercado nulo */
    private onChangeNullOption() {
        this.nullOption = this.idsMercados.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção dos mercados */
    onChange() {
        this.onChangeNullOption();
        this.idsMercadosChange.emit(this.idsMercados);
    }
}
